import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";
import { SharedModule } from "src/app/shared/shared.module";

import { LeaveConfirmationDialogActions } from "./leave-job-confirm.actions";

@Component({
    selector: 'app-leave-job-confirm',
    standalone: true,
    imports: [
      SharedModule,
      FreyaCommonModule,
    ],
    templateUrl: './leave-job-confirm.component.html',
    styleUrls: ['./leave-job-confirm.component.scss']
  })
  export class LeaveJobConfirmComponent {

    public actions = LeaveConfirmationDialogActions;

    constructor(
      public store: Store,
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
    ) {}
  }
